import ListBaladiyaUpdate from "./ListBaladiyaUpdate";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBaladiyaData } from "../../../../../store/Api";

export default function BaladiyaUpdate({ setIndex }) {
  // const Baladiyadata = useSelector((state) => state.baladiyaData);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  // useEffect(() => {
  //   dispatch(getBaladiyaData(token));
  // }, []);

  // const updateData = () => {
  //   dispatch(getBaladiyaData(token));
  // };

  return (
    <ListBaladiyaUpdate
      // list={Baladiyadata.data?.data}
      loading={loading}
      titles={[
        "SR.NO.",
        "EMPLOYEE ID",
        "EMPLOYEE NAME",
        "Actual Profession",
        "IQAMA Profession",
        "visa Provider",
        "Sponser Id",
        "Client",
        "IQAMA Number",
        "Baladiya LOCATION",
        "Baladiya APPLY DATE",
        "Baladiya ISSUE DATE",
        "BALADIYA EXPIRY DATE",
        "Baladiya VALID DAYS",
        "STATUS",
        "checkBox",
      ]}
      token={token}
      // updateData={updateData}
      uploadFile={""}
      setIndex={setIndex}
    />
  );
}
